import { useEffect, useState } from 'react';

/** Subscribes to a media query. Drives layout mode, so it must match the CSS breakpoints
 *  in tokens.css exactly — a mismatch shows up as a drawer that renders behind a column. */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );
  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    setMatches(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);
  return matches;
}

export const useIsMobile = () => useMediaQuery('(max-width: 900px)');
/** Below this the right rail overlays instead of holding a column. */
export const useRailOverlays = () => useMediaQuery('(max-width: 1100px)');
